import { useState } from 'react';
import clsx from 'clsx';
import { Icon } from '../../../layout/Icon.jsx';
import { PlatformModal, Field } from './PlatformModal.jsx';

/** حذف شركة — يتطلّب كتابة كود الشركة، وحذف البيانات اختيار منفصل وواضح. */
export function DeleteCompanyModal({ company, pending, onClose, onConfirm }) {
  const [typed, setTyped] = useState('');
  const [dropData, setDropData] = useState(false);
  const slug = company?.slug || '';
  const match = typed.trim() === slug && !!slug;

  return (
    <PlatformModal
      title="حذف الشركة"
      sub={company ? company.name : undefined}
      onClose={onClose}
      width={500}
      footer={(
        <>
          <button type="button" className="btn flex-1 justify-center" onClick={onClose}>إلغاء</button>
          <button
            type="button"
            className="btn btn-danger flex-1 justify-center"
            onClick={() => onConfirm({ dropData })}
            disabled={!match || pending}
          >
            <Icon name="trash" size={14} />
            {pending ? 'جاري الحذف...' : dropData ? 'حذف الشركة وبياناتها' : 'حذف الشركة'}
          </button>
        </>
      )}
    >
      <div
        className="rounded-[10px] p-2.5 text-[12.5px] font-semibold flex items-start gap-2"
        style={{ background: '#FEE2E2', color: '#B91C1C' }}
      >
        <Icon name="bell" size={16} />
        <span>هذا الإجراء لا يمكن التراجع عنه. سيفقد جميع مستخدمي الشركة إمكانية الدخول.</span>
      </div>

      <Field
        label="للتأكيد اكتب كود الشركة"
        required
        hint={'الكود المطلوب: ' + (slug || '—')}
      >
        <input
          className={clsx('input font-mono', typed && !match && 'border-red')}
          value={typed}
          autoFocus
          dir="ltr"
          style={{ textAlign: 'left' }}
          onChange={(e) => setTyped(e.target.value)}
          placeholder={slug}
        />
      </Field>

      <label
        className="flex items-start gap-2 cursor-pointer rounded-[10px] p-2.5 border"
        style={dropData
          ? { background: '#FEE2E2', borderColor: '#FCA5A5' }
          : { background: '#FFF', borderColor: '#EFE7D6' }}
      >
        <input
          type="checkbox"
          className="accent-orange mt-0.5"
          checked={dropData}
          onChange={(e) => setDropData(e.target.checked)}
        />
        <span className="text-[12.5px]">
          <b>حذف بيانات الشركة نهائياً</b>
          <div className="text-[11.5px] mt-0.5" style={{ color: dropData ? '#B91C1C' : '#9CA3AF' }}>
            إسقاط قاعدة بيانات الشركة بكل ما فيها (المستخدمون، الجلسات، الفواتير، التقارير).
            اتركه فارغاً لحذف سجل الشركة فقط مع الإبقاء على قاعدة بياناتها.
          </div>
        </span>
      </label>
    </PlatformModal>
  );
}
